export const OTHER_SPACE_KEY = '__other__';

export const SPACE_TONES = [
  { chip: 'bg-gradient-to-br from-rose-200 via-pink-100 to-orange-200 text-rose-950 border-rose-200 dark:from-rose-900/90 dark:via-pink-900/60 dark:to-orange-900/50 dark:text-rose-100 dark:border-rose-800', chipSelected: 'bg-gradient-to-br from-rose-600 via-pink-500 to-orange-400 text-white border-rose-400/30', dot: 'bg-rose-500', title: 'bg-gradient-to-r from-rose-600 via-pink-500 to-orange-400 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-orange-200 via-amber-100 to-yellow-200 text-orange-950 border-orange-200 dark:from-orange-900/90 dark:via-amber-900/60 dark:to-yellow-900/50 dark:text-orange-100 dark:border-orange-800', chipSelected: 'bg-gradient-to-br from-orange-600 via-amber-500 to-yellow-400 text-white border-orange-400/30', dot: 'bg-orange-500', title: 'bg-gradient-to-r from-orange-600 via-amber-500 to-yellow-500 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-amber-200 via-yellow-100 to-orange-200 text-amber-950 border-amber-200 dark:from-amber-900/90 dark:via-yellow-900/55 dark:to-orange-900/50 dark:text-amber-100 dark:border-amber-800', chipSelected: 'bg-gradient-to-br from-amber-600 via-yellow-500 to-orange-400 text-white border-amber-400/30', dot: 'bg-amber-500', title: 'bg-gradient-to-r from-amber-600 via-yellow-500 to-orange-400 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-lime-200 via-green-100 to-emerald-200 text-lime-950 border-lime-200 dark:from-lime-900/90 dark:via-green-900/60 dark:to-emerald-900/50 dark:text-lime-100 dark:border-lime-800', chipSelected: 'bg-gradient-to-br from-lime-600 via-green-500 to-emerald-500 text-white border-lime-400/30', dot: 'bg-lime-500', title: 'bg-gradient-to-r from-lime-600 via-green-500 to-emerald-500 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-emerald-200 via-teal-100 to-cyan-200 text-emerald-950 border-emerald-200 dark:from-emerald-900/90 dark:via-teal-900/60 dark:to-cyan-900/50 dark:text-emerald-100 dark:border-emerald-800', chipSelected: 'bg-gradient-to-br from-emerald-600 via-teal-500 to-cyan-500 text-white border-emerald-400/30', dot: 'bg-emerald-500', title: 'bg-gradient-to-r from-emerald-600 via-teal-500 to-cyan-500 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-teal-200 via-cyan-100 to-sky-200 text-teal-950 border-teal-200 dark:from-teal-900/90 dark:via-cyan-900/60 dark:to-sky-900/50 dark:text-teal-100 dark:border-teal-800', chipSelected: 'bg-gradient-to-br from-teal-600 via-cyan-500 to-sky-500 text-white border-teal-400/30', dot: 'bg-teal-500', title: 'bg-gradient-to-r from-teal-600 via-cyan-500 to-sky-500 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-cyan-200 via-sky-100 to-blue-200 text-cyan-950 border-cyan-200 dark:from-cyan-900/90 dark:via-sky-900/60 dark:to-blue-900/50 dark:text-cyan-100 dark:border-cyan-800', chipSelected: 'bg-gradient-to-br from-cyan-600 via-sky-500 to-blue-500 text-white border-cyan-400/30', dot: 'bg-cyan-500', title: 'bg-gradient-to-r from-cyan-600 via-sky-500 to-blue-500 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-sky-200 via-blue-100 to-indigo-200 text-sky-950 border-sky-200 dark:from-sky-900/90 dark:via-blue-900/60 dark:to-indigo-900/50 dark:text-sky-100 dark:border-sky-800', chipSelected: 'bg-gradient-to-br from-sky-600 via-blue-500 to-indigo-500 text-white border-sky-400/30', dot: 'bg-sky-500', title: 'bg-gradient-to-r from-sky-600 via-blue-500 to-indigo-500 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-indigo-200 via-violet-100 to-purple-200 text-indigo-950 border-indigo-200 dark:from-indigo-900/90 dark:via-violet-900/60 dark:to-purple-900/50 dark:text-indigo-100 dark:border-indigo-800', chipSelected: 'bg-gradient-to-br from-indigo-600 via-violet-500 to-purple-500 text-white border-indigo-400/30', dot: 'bg-indigo-500', title: 'bg-gradient-to-r from-indigo-600 via-violet-500 to-purple-500 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-violet-200 via-fuchsia-100 to-pink-200 text-violet-950 border-violet-200 dark:from-violet-900/90 dark:via-fuchsia-900/60 dark:to-pink-900/50 dark:text-violet-100 dark:border-violet-800', chipSelected: 'bg-gradient-to-br from-violet-600 via-fuchsia-500 to-pink-500 text-white border-violet-400/30', dot: 'bg-violet-500', title: 'bg-gradient-to-r from-violet-600 via-fuchsia-500 to-pink-500 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-fuchsia-200 via-pink-100 to-rose-200 text-fuchsia-950 border-fuchsia-200 dark:from-fuchsia-900/90 dark:via-pink-900/60 dark:to-rose-900/50 dark:text-fuchsia-100 dark:border-fuchsia-800', chipSelected: 'bg-gradient-to-br from-fuchsia-600 via-pink-500 to-rose-500 text-white border-fuchsia-400/30', dot: 'bg-fuchsia-500', title: 'bg-gradient-to-r from-fuchsia-600 via-pink-500 to-rose-500 bg-clip-text text-transparent' },
  { chip: 'bg-gradient-to-br from-pink-200 via-rose-100 to-orange-200 text-pink-950 border-pink-200 dark:from-pink-900/90 dark:via-rose-900/60 dark:to-orange-900/50 dark:text-pink-100 dark:border-pink-800', chipSelected: 'bg-gradient-to-br from-pink-600 via-rose-500 to-orange-400 text-white border-pink-400/30', dot: 'bg-pink-500', title: 'bg-gradient-to-r from-pink-600 via-rose-500 to-orange-400 bg-clip-text text-transparent' },
];

export const spaceTone = (key) => {
  const value = String(key || '');
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 33 + value.charCodeAt(i)) >>> 0;
  }
  return SPACE_TONES[hash % SPACE_TONES.length];
};

export const resolveItemSpace = (item) => {
  const spaceId = String(item?.spaceId || item?.workflowSpaceId || '').trim();
  const spaceName = String(item?.spaceName || item?.workflowSpaceName || '').trim();
  if (spaceId) {
    return { key: spaceId, name: spaceName || 'Space' };
  }
  if (spaceName) {
    return { key: `name:${spaceName.toLowerCase()}`, name: spaceName };
  }
  return { key: OTHER_SPACE_KEY, name: 'My space' };
};

export const workflowSpaceIndex = (workflows = []) => {
  const map = new Map();
  (workflows || []).forEach((item) => {
    const id = String(item?.messageId || '').trim();
    if (!id) return;
    map.set(id, resolveItemSpace(item));
  });
  return map;
};

export const linkedWorkflowIdsForTask = (task) => {
  const ids = [];
  const seen = new Set();
  const add = (value) => {
    const id = value != null ? String(value).trim() : '';
    if (!id || seen.has(id)) return;
    seen.add(id);
    ids.push(id);
  };
  const extras = task?.workflowMessageIds;
  if (Array.isArray(extras)) extras.forEach(add);
  add(task?.messageId);
  return ids;
};

export const resolveTaskSpace = (task, workflowSpaces) => {
  const own = resolveItemSpace(task);
  if (own.key !== OTHER_SPACE_KEY) return own;
  const lookup = workflowSpaces instanceof Map
    ? (id) => workflowSpaces.get(id)
    : (id) => workflowSpaces?.[id];
  for (const id of linkedWorkflowIdsForTask(task)) {
    const inherited = lookup(id);
    if (inherited && inherited.key !== OTHER_SPACE_KEY) return inherited;
  }
  return own;
};

export const collectTodaySpaceGroups = (tasks = [], workflows = []) => {
  const workflowSpaces = workflowSpaceIndex(workflows);
  const map = new Map();
  const bump = (space, field) => {
    if (!space?.key) return;
    const existing = map.get(space.key) || {
      key: space.key,
      name: space.name,
      taskCount: 0,
      workflowCount: 0,
      count: 0,
    };
    existing[field] += 1;
    existing.count = existing.taskCount + existing.workflowCount;
    if (space.name && space.name !== 'My space') existing.name = space.name;
    map.set(space.key, existing);
  };

  (tasks || []).forEach((task) => {
    if (!task) return;
    if (String(task.mapTaskId || '').trim()) return;
    bump(resolveTaskSpace(task, workflowSpaces), 'taskCount');
  });

  (workflows || []).forEach((item) => {
    if (!String(item?.messageId || '').trim()) return;
    bump(resolveItemSpace(item), 'workflowCount');
  });

  return [...map.values()].sort((a, b) => {
    if (a.key === OTHER_SPACE_KEY) return 1;
    if (b.key === OTHER_SPACE_KEY) return -1;
    return String(a.name).localeCompare(String(b.name));
  });
};

export const spaceWorkLabel = (group) => {
  const workflows = Number(group?.workflowCount) || 0;
  const tasks = Number(group?.taskCount) || 0;
  const workflowPart = workflows === 1 ? '1 workflow' : `${workflows} workflows`;
  const taskPart = tasks === 1 ? '1 task' : `${tasks} tasks`;
  if (workflows > 0 && tasks > 0) return `${workflowPart} → ${taskPart}`;
  if (workflows > 0) return workflowPart;
  return taskPart;
};

/** Share of pending parent tasks per space; values sum to 100 (or all 0). */
export const pendingSharePercents = (groups = []) => {
  const list = Array.isArray(groups) ? groups : [];
  const result = {};
  const weights = list.map((group) => Math.max(0, Number(group?.taskCount) || 0));
  const total = weights.reduce((sum, value) => sum + value, 0);
  if (total <= 0) {
    list.forEach((group) => {
      if (group?.key) result[group.key] = 0;
    });
    return result;
  }
  const floors = weights.map((weight) => Math.floor((weight * 100) / total));
  let assigned = floors.reduce((sum, value) => sum + value, 0);
  const leftover = 100 - assigned;
  const order = floors.map((_, index) => index).sort((a, b) => {
    const remA = (weights[a] * 100) / total - floors[a];
    const remB = (weights[b] * 100) / total - floors[b];
    if (remB !== remA) return remB - remA;
    return weights[b] - weights[a];
  });
  const shares = floors.slice();
  for (let i = 0; i < leftover && i < order.length; i += 1) {
    shares[order[i]] += 1;
  }
  list.forEach((group, index) => {
    if (group?.key) result[group.key] = shares[index];
  });
  return result;
};

export const spaceWorkCompact = (group) => {
  const workflows = Number(group?.workflowCount) || 0;
  const tasks = Number(group?.taskCount) || 0;
  if (workflows > 0 && tasks > 0) return `${workflows}→${tasks}`;
  if (workflows > 0) return String(workflows);
  return String(tasks);
};

export const spaceInitials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
};

export const SPACE_ICON_PRESETS = ['🚀', '📁', '💼', '🏠', '🎯', '⭐', '🔥', '🧩', '🧠', '🛠️', '📦', '💡'];

export const shouldShowSpacesTab = (groups = []) => (
  groups.filter((group) => group.key !== OTHER_SPACE_KEY).length >= 2
  || (groups.some((group) => group.key !== OTHER_SPACE_KEY) && groups.some((group) => group.key === OTHER_SPACE_KEY))
);
